import { Select } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface BranchAreaSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  customer?: any;
  onChange?: (value: any) => void;
  onSelect?: (customer: any) => void;
}

const BranchAreaSelect: React.FC<BranchAreaSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  onChange,
  onSelect,
}) => {
  const [state, updateState] = useState<any[]>([]);

  const loadFirst = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(`/settings/branch_area/list`);
      const list = result?.data || [];
      updateState(list);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const changeHandler = useCallback(
    (value: string) => {
      const item = state.find((it: any) => it?.no === value);
      if (onChange) onChange(value);
      if (onSelect) onSelect(item);
    },
    [state, onSelect, onChange]
  );

  useEffect(() => {
    loadFirst();
  }, []);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.name,
        value: item.no,
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Хүргэлт сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      onChange={changeHandler}
      options={options}
      disabled={disabled}
      value={value}
      filterOption={false}
    />
  );
};

export default BranchAreaSelect;
